var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.bills && _vm.bills.length > 0
    ? _c("ListView", {
        attrs: {
          data: _vm.bills,
          loading: _vm.loading,
          "repository-function": _vm.repositoryFunction,
          type: _vm.type
        }
      })
    : _c(
        "v-container",
        {
          staticClass: "empty-state",
          attrs: {
            "pa-0": "",
            "ma-0": "",
            fluid: "",
            "justify-center": "",
            "fill-height": ""
          }
        },
        [
          _c("div", [
            _c("img", {
              attrs: {
                src: require("@/assets/empty-state-invoices.png"),
                alt: "No hay facturas para listar"
              }
            }),
            _c("p", [_vm._v("No hay facturas para listar")])
          ])
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }